import { cn } from "../utils/cn";

/** Shared visual language for button-like controls (Button, IconButton) so
 *  variant colors live in one place. */
export type ControlVariant =
  "primary" | "secondary" | "ghost" | "brand" | "danger";

export const CONTROL_BASE = cn(
  "inline-flex items-center justify-center whitespace-nowrap border",
  "font-sans font-medium transition-colors duration-fast ease-ai21-standard",
  "cursor-pointer select-none",
  "focus-visible:outline-none focus-visible:shadow-focus",
  "disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-fg-4",
);

// Border color is set in exactly one place per variant (default hairline for
// secondary, transparent otherwise) to avoid Tailwind class-order conflicts.
export const CONTROL_VARIANT_CLASSES: Record<ControlVariant, string> = {
  primary:
    "border-transparent bg-brand-800 text-grey-50 hover:bg-brand-900 active:bg-brand-950",
  secondary:
    "bg-surface text-fg-1 hover:bg-surface-subtle active:bg-surface-muted",
  ghost:
    "border-transparent bg-transparent text-fg-1 hover:bg-surface-subtle active:bg-surface-muted",
  brand:
    "border-transparent bg-brand-700 text-grey-50 hover:bg-brand-800 active:bg-brand-900",
  danger:
    "border-transparent bg-error-fg text-grey-0 hover:opacity-90 active:opacity-80",
};
